// Lib
import {
    emailFormat,
    minLength,
    onlyNumbers,
    regex,
    required,
    validKatakana,
    validNormalPhone,
    validPhoneNumber,
    validZipCode,
} from '../validator';

// Type
import { TypeOfT } from 'utils/type/translations/Translation.type';

const createWorkerValidation = (t: TypeOfT) => ({
    identification: () => ({
        required: required('identification', t),
    }),
    name: () => ({
        required: required('worker_name', t),
    }),
    kana: () => ({
        // required: required('worker_kana', t),
        minLength: minLength('worker_kana', 2, t),
        validate: {
            validKatakana: validKatakana('worker_kana', t),
        },
    }),
    gender_type: () => ({
        required: required('worker_gender_type', t),
    }),
    cooperative_company_id: () => ({
        required: required('cooperative_company_id', t),
    }),
    department_id: () => ({
        required: required('department_id', t),
    }),
    position_id: () => ({
        required: required('position_id', t),
    }),
    celphone: () => ({
        // required: required('celphone', t),
        validate: {
            onlyNumbers: onlyNumbers('celphone', t),
        },
    }),
    fax: () => ({
        required: required('fax', t),
        // validate: {
        //     onlyNumbers: onlyNumbers('celphone', t),
        // },
    }),
    email: () => ({
        // required: required('email', t),
        validate: {
            emailFormat: emailFormat('email', t),
        },
    }),
    phone: () => ({
        // required: required('phone', t),
        validate: {
            onlyNumbers: onlyNumbers('phone', t),
        },
    }),
    zipcode: () => ({
        // required: required('zipcode', t),
        validate: {
            regex: validZipCode('zipcode', t),
        },
    }),
    birthday: () => ({
        required: required('birthday', t),
    }),
    address: () => ({
        required: required('address', t),
    }),
});

export default createWorkerValidation;
